import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=2be87c60&scoped=true"
import script from "./tagInput.vue?vue&type=script&lang=js"
export * from "./tagInput.vue?vue&type=script&lang=js"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=2be87c60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be87c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be87c60')) {
      api.createRecord('2be87c60', component.options)
    } else {
      api.reload('2be87c60', component.options)
    }
    module.hot.accept("./tagInput.vue?vue&type=template&id=2be87c60&scoped=true", function () {
      api.rerender('2be87c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tagInput.vue"
export default component.exports